module.exports = "dist/governo-do-estado.png?467591e4bb33b3be310a5b976cf9bad8";